import cn from 'classnames';
import React, {FC, useEffect} from 'react';
import {useSelector} from 'react-redux';

import {AppButton} from '../../../../../components/Button';
import {getReconnectDeviceGuideData} from '../../../../../config/dataConfig/dataConfig';
import * as reconnectGuideTypes from '../../../../../consts/app/reconnectGuideTypes';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import analyticsService from '../../../../../services/analyticsService';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import {showReconnectDeviceGuideModalAction} from '../../../../../state/ducks/modal';
import {makeSelectIotDeviceMergedWithConsumerProduct} from '../../../../../state/selectors/consumer';
import {dispatch} from '../../../../../state/store';

interface IProps {
    onClick: () => void;
    hideNotification: () => void;
}

const ReconnectNotification: FC<IProps> = (props) => {
    const {onClick, hideNotification} = props;
    const iotProduct = useSelector(makeSelectIotDeviceMergedWithConsumerProduct());
    const {device} = iotProduct || {};
    const {name = '', type} = device || {};

    useEffect(() => {
        if (!name) {
            hideNotification();
        }
    }, [name]);

    useEffect(() => {
        analyticsService.pushBleReconnectionNotificationEvent(type);
    }, []);

    const reconnectDeviceGuideData = getReconnectDeviceGuideData(type);
    const localizedStrings = getLocalizedStrings();
    const notificationText = localizedStrings.formatString(
        localizedStrings[localizationKeys.DEVICE_LOST_CONNECTION_NOTIFICATION_PART_1],
        name
    );
    const buttonText = localizedStrings[localizationKeys.DEVICE_LOST_CONNECTION_NOTIFICATION_PART_2];

    const onButtonClick = () => {
        onClick();
        dispatch(showReconnectDeviceGuideModalAction({guideType: reconnectGuideTypes.REGULAR}));
    };

    return (
        <>
            <span className={cn({'pr-1': notificationText})}>{notificationText}</span>
            {reconnectDeviceGuideData && (
                <AppButton tertiary onClick={onButtonClick} className='inline-block'>
                    {buttonText}
                </AppButton>
            )}
        </>
    );
};

export default ReconnectNotification;
